import { RequestState } from './Store';

export interface DeliveryPreference {
  instruction: SafeDropInstruction | null;
  location?: string | null;
  options: DeliveryPreferenceOptions[];
}

export interface DeliveryPreferenceOptions {
  code: string;
  value: string;
  selected: boolean;
}
export interface DeliveryPreferenceState extends RequestState {
  data: DeliveryPreference | null;
}

export const SafeDropInstruction = {
  UNSET: 'UNSET',
  OFF: 'OFF',
  ON: 'ON',
} as const;
export type SafeDropInstruction = (typeof SafeDropInstruction)[keyof typeof SafeDropInstruction];
